import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";

const CalendarToggleButton = ({ view, handleViewChange }) => {
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 3 }}>
      <ToggleButtonGroup
        value={view}
        exclusive
        onChange={handleViewChange}
        size="small"
      >
        <ToggleButton
          value="table"
          sx={{
            width: "120px",
            "&.Mui-selected": {
              backgroundColor: theme.palette.warning.light,
              "&:hover": {
                backgroundColor: theme.palette.warning.light,
              },
            },
          }}
        >
          ТАБЛИЦА
        </ToggleButton>
        <ToggleButton
          value="calendar"
          sx={{
            width: "120px",
            "&.Mui-selected": {
              backgroundColor: theme.palette.warning.light,
              "&:hover": {
                backgroundColor: theme.palette.warning.light,
              },
            },
          }}
        >
          КАЛЕНДАР
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default CalendarToggleButton;
